//reimport

import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const reimportApi = createApi({

    reducerPath: "reimportApi",
    baseQuery,
    tagTypes: ["reimport"],
    endpoints: (builder) => ({
        createReimport: builder.mutation({
            query: ({ id, ...data }) => ({ ///v1/import/product/reImport/{importProductId}/{importProductReImportId}
                url: `/import/product/reImport/${id}`,
                method: "PUT",
                body: { ProductReImport: data },
                headers: {
                    "X-Request-Id": Math.random().toString(36).substring(2),
                },
            }),
            invalidatesTags: ["reimport"],
        }),

        getReimportById: builder.query({
            query: ({ id }) => `/import/product/reImport/${id}`,
            transformResponse: (response) => {
                const data = response?.data ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item, index) => ({
                    ...item,
                    SrNo: index + 1,
                    id: item.importProductReImportId, //  use backend's exportEntityId
                }));

            },
            providesTags: ["reimport"],
        }),

        updateReimport: builder.mutation({
            query: ({ id, subId, ...data }) => {

                return {
                    url: `/import/product/reImport/${id}/${subId}`,
                    method: "PUT",
                    body: { ProductReImport: data },
                    headers: {
                        "X-Request-Id": Math.random().toString(36).substring(2),
                    },
                };
            },
            invalidatesTags: ["reimport"],
        }),

        deleteReimport: builder.mutation({
            query: ({ id }) => ({
                url: `/import/product/reImport/${id}`,
                method: "DELETE",
                headers: {
                    "X-Request-Id": Math.random().toString(36).substring(2),
                },
            }),
            invalidatesTags: ["reimport"],
        }),



    }),
});
export const {
    useCreateReimportMutation,
    useLazyGetReimportByIdQuery,
    useUpdateReimportMutation,
    useDeleteReimportMutation






} = reimportApi;
